<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="large"
  color="#fff"
  type="ball-spin"
  [fullScreen]="true"
  ><p style="color: white">Loading...</p></ngx-spinner
>
<dq-page-template></dq-page-template>
